import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import "./Mobile.css";
import Testimonial from "../../../Testimonial/Testimonial";

const Mobile = () => {
  const techItemsRow1 = [
    { name: "Angular.js", logo: "/logos/angular.png" },
    { name: "HTML", logo: "/logos/html.png" },
    { name: "CSS3", logo: "/logos/css.png" },
    { name: "Bootstrap", logo: "/logos/bootstrap.png" },
    { name: "Javascript", logo: "/logos/javascript.png" },
    { name: "AmazonDB", logo: "/logos/amazon_dynamodb.png" },
    { name: "Appian", logo: "/logos/appian.png" },
    { name: "Laravel", logo: "/logos/laravel.png" },
    { name: "MariaDB", logo: "/logos/mariadb.png" },
    { name: "MongoDB", logo: "/logos/mongodb.png" },
    { name: "Android", logo: "/logos/android-5.png" },
    { name: "ERC-20", logo: "/logos/erc-20.png" },
    { name: "Ethereum", logo: "/logos/ethereum.png" },
    { name: "Flutter", logo: "/logos/flutter.png" },
    { name: "Ionic", logo: "/logos/ionic.png" },
    { name: "Augmented Reality", logo: "/logos/Augmented Reality.png" },
    { name: "Crda", logo: "/logos/crda.png" },
    { name: "Data Science", logo: "/logos/data-science.png" },
    { name: "Go Chain", logo: "/logos/gochain.png" },
  ];

  const techItemsRow2 = [
    { name: "Sass", logo: "/logos/saas.png" },
    { name: "JQuery", logo: "/logos/jquery.png" },
    { name: "Less", logo: "/logos/less.png" },
    { name: "Codeigniter", logo: "/logos/codeignitor.png" },
    { name: "Django", logo: "/logos/django.png" },
    { name: "Node JS", logo: "/logos/node js.png" },
    { name: "PHP", logo: "/logos/php.png" },
    { name: "Salesforce", logo: "/logos/salesforce.png" },
    { name: "SQL Server", logo: "/logos/sql-server.png" },
    { name: "MySQL", logo: "/logos/mysql-5.png" },
    { name: "IOS", logo: "/logos/ios.png" },
    { name: "Oracle 6", logo: "/logos/oracle.png" },
    { name: "PostgreSQL", logo: "/logos/postgresql.png" },
    { name: "React Native", logo: "/logos/react_native.png" },
    { name: "Solidity", logo: "/logos/Solidity.png" },
    { name: "Hyperledger", logo: "/logos/Hyperledger.png" },
    { name: "Internet Of Things", logo: "/logos/iot.png" },
    { name: "One Ledger", logo: "/logos/OneLedger.png" },
    { name: "Virtual Reality", logo: "/logos/virtual-reality.png" },
  ];

  const duplicatedRow1 = [...techItemsRow1, ...techItemsRow1];
  const duplicatedRow2 = [...techItemsRow2, ...techItemsRow2];

  const containerRef = useRef(null);
  const row1Ref = useRef(null);
  const row2Ref = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const [offset, setOffset] = useState(0);
  const animationRef = useRef();

  useEffect(() => {
    // Set initial container width
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth);
    }

    const handleResize = () => {
      if (containerRef.current) {
        setContainerWidth(containerRef.current.offsetWidth);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const scrollSpeed = 1; // Adjust speed as needed (pixels per frame)

    const animate = () => {
      setOffset((prevOffset) => {
        const maxOffset = row1Ref.current?.scrollWidth / 2 || 0;
        const newOffset = prevOffset + scrollSpeed;
        return newOffset >= maxOffset ? 0 : newOffset;
      });
      animationRef.current = requestAnimationFrame(animate);
    };

    animationRef.current = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(animationRef.current);
    };
  }, [containerWidth]);

    const [activeFeature, setActiveFeature] = useState(0);

 const mobileServices = [
    {
      title: "Responsive Design",
      description: "Websites that adapt beautifully to all mobile devices.",
      icon: "📱"
    },
    {
      title: "Mobile Apps",
      description: "Native and cross-platform applications for iOS and Android.",
      icon: "📲"
    },
    {
      title: "Progressive Web Apps",
      description: "Web applications that feel like native apps on mobile devices.",
      icon: "⚡"
    },
    {
      title: "Mobile Optimization",
      description: "Speed and performance optimization for mobile users.",
      icon: "🚀"
    },
    {
      title: "UI/UX Mobile Design",
      description: "Intuitive interfaces designed specifically for mobile experiences.",
      icon: "🎨"
    },
    {
      title: "Mobile E-Commerce",
      description: "Shopping experiences optimized for mobile conversions.",
      icon: "🛒"
    },
    {
      title: "Mobile API Integration",
      description: "Seamless connection between your app and backend services.",
      icon: "🔌"
    },
    {
      title: "Mobile Analytics",
      description: "Track and analyze user behavior on mobile platforms.",
      icon: "📊"
    }
  ];

  const features = [
    "Touch-friendly interfaces",
    "Gesture-based navigation",
    "Offline functionality",
    "Push notifications",
    "Camera integration",
    "GPS services",
    "Payment integration",
    "Social media integration"
  ];



  return (
    <div>
      <Helmet>
        <title>Mobile Development Solutions | Cross-Platform & Native App Expertise</title>
        <meta 
          name="description" 
          content="Comprehensive mobile app development services including native iOS/Android and cross-platform solutions using Flutter, React Native, and Ionic for superior mobile experiences." 
        />
        <meta 
          name="keywords" 
          content="mobile app development, iOS development, Android development, cross-platform apps, Flutter development, React Native, Ionic framework, mobile UI/UX, app design, mobile architecture, Swift programming, Kotlin development, Java for Android, mobile backend, app performance optimization, mobile security, push notifications, in-app purchases, mobile analytics, app store optimization, PWA development, hybrid apps, mobile API integration, Firebase for mobile, mobile testing, app debugging, mobile CI/CD, app localization, mobile accessibility, AR mobile apps, mobile machine learning, IoT mobile integration, blockchain mobile apps, mobile payment integration, geolocation services, mobile cloud services, mobile DevOps, app maintenance, mobile MVP development, enterprise mobile apps, consumer mobile apps, mobile UX best practices, app prototyping, mobile animation, offline mobile apps, mobile database solutions, mobile authentication, mobile SDK integration" 
        />
      </Helmet>
      

          <div className="mk-mobile-page">
      <div className="mk-mobile-hero">
        <div className="mk-mobile-hero-content">
          <h1 className="mk-mobile-title">Mobile Solutions</h1>
          <p className="mk-mobile-subtitle">Creating exceptional mobile experiences that engage your audience</p>
          <a href="/contact-us"><button className="mk-mobile-cta">Get Started</button></a>
        </div>
        <div className="mk-mobile-hero-visual">
          <div className="mk-floating-phone">
            <div className="mk-phone-screen">
              <div className="mk-screen-content">
                <div className="mk-app-icon">M</div>
                <p>MK eTech Mobile</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mk-mobile-services">
        <h2 className="mk-section-title">Our Mobile Services</h2>
        <div className="mk-services-grid">
          {mobileServices.map((service, index) => (
            <div 
              key={index} 
              className="mk-service-card"
              onMouseEnter={() => setActiveFeature(index)}
            >
              <div className="mk-service-icon">{service.icon}</div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="mk-mobile-features">
        <h2 className="mk-section-title">Mobile Features</h2>
        <div className="mk-features-list">
          {features.map((feature, index) => (
            <div 
              key={index} 
              className={`mk-feature-item ${index === activeFeature ? 'mk-feature-active' : ''}`}
            >
              <span className="mk-feature-check">✓</span>
              <span>{feature}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="mk-mobile-showcase">
        <h2 className="mk-section-title">Why Choose Our Mobile Solutions?</h2>
        <div className="mk-showcase-content">
          <div className="mk-showcase-text">
            <p>Our team specializes in creating mobile experiences that convert visitors into customers. We combine cutting-edge technology with user-centered design to deliver solutions that perform exceptionally on all mobile devices.</p>
            <ul>
              <li>Increased mobile engagement</li>
              <li>Higher conversion rates</li>
              <li>Faster loading times</li>
              <li>Improved search rankings</li>
            </ul>
          </div>
          <div className="mk-showcase-stats">
            <div className="mk-stat">
              <h3>87%</h3>
              <p>Mobile Traffic Increase</p>
            </div>
            <div className="mk-stat">
              <h3>2.5x</h3>
              <p>Faster Load Times</p>
            </div>
            <div className="mk-stat">
              <h3>42%</h3>
              <p>Higher Conversion Rate</p>
            </div>
          </div>
        </div>
      </div>
    </div>


      
      <Testimonial />

      <div className="tech-slider-container" ref={containerRef}>
        <h2 className="tech-slider-title">Tools & Tech Stack</h2>
        <div className="tech-slider-divider"></div>

        {/* First row */}
        <div className="tech-slider-wrapper">
          <div
            className="tech-slider-row"
            ref={row1Ref}
            style={{ transform: `translateX(-${offset}px)` }}
          >
            {duplicatedRow1.map((tech, index) => (
              <div key={`row1-${index}`} className="tech-slide">
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="tech-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logos/default.png";
                  }}
                />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Second row */}
        <div className="tech-slider-wrapper">
          <div
            className="tech-slider-row"
            ref={row2Ref}
            style={{ transform: `translateX(-${offset}px)` }}
          >
            {duplicatedRow2.map((tech, index) => (
              <div key={`row2-${index}`} className="tech-slide">
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="tech-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logos/default.png";
                  }}
                />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Mobile;